import { createAction, props } from '@ngrx/store';
import {FirmaItem} from '../../firma.model';

export const loadFirmaStart = createAction('MITARBEITERVERWALTUNG::LOAD_FIRMA_START');
export const loadFirmaSucceeded = createAction(
    'MITARBEITERVERWALTUNG::LOAD_FIRMA_SUCCEEDED',
    props<{ item: FirmaItem }>(),
);
export const loadFirmaFailed = createAction('MITARBEITERVERWALTUNG::LOAD_FIRMA_FAILED', props<{ error: Error }>());
